import { AppThunk } from '../../../store/rootReducer';
import { trackDeleteWave } from '../../analytics/thunks/track-delete-wave.thunk';
import {
  selectedIdsSelector,
  waveForIdSelector,
} from '../selectors/wave.selectors';
import { deleteWaves } from './delete-waves.thunk';

export const deleteSelectedWaves =
  (): AppThunk =>
  (dispatch, getState): boolean => {
    const waveIds = selectedIdsSelector(getState());
    if (waveIds.length > 0) {
      const selectedWave = waveForIdSelector(waveIds[0])(getState());
      if (selectedWave != null) {
        dispatch(trackDeleteWave(selectedWave, 'keyboard'));
      }
      dispatch(deleteWaves(waveIds));
      return true;
    }
    return false;
  };
